import React from 'react';
import { createPortal } from 'react-dom';

export default function LessonActionsModal({ open, onClose, lesson, onPreview, onEdit, onPublish }) {
  if (!open) return null;
  const cover = lesson?.cover || lesson?.bannerImage || lesson?.imageUrl || '';
  return createPortal(
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 99998, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ width: 420, maxWidth: '95vw', background: '#fff', borderRadius: 12, boxShadow: '0 20px 60px rgba(0,0,0,0.25)', overflow: 'hidden' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 12, borderBottom: '1px solid #eee' }}>
          {cover ? <img src={cover} alt="cover" style={{ width: 56, height: 56, borderRadius: 8, objectFit: 'cover' }} /> : null}
          <div style={{ flex: 1 }}>
            <div style={{ fontWeight: 700 }}>{lesson?.title || 'Untitled'}</div>
            <div style={{ fontSize: 12, color: '#6b7280' }}>{(lesson?.description || '').slice(0, 120)}</div>
          </div>
          <button onClick={onClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 18 }}>✕</button>
        </div>
        <div style={{ padding: 16, display: 'flex', gap: 10, justifyContent: 'space-between' }}>
          <button className="chip" onClick={onPreview} style={{ flex: 1 }}>Preview</button>
          <button className="chip" onClick={onEdit} style={{ flex: 1 }}>Edit</button>
          <button className="chip" onClick={onPublish} style={{ flex: 1, background: 'linear-gradient(135deg, #38b6ff, #00bf63)', color: '#fff' }}>Publish</button>
        </div>
      </div>
    </div>,
    document.body
  );
}


